module.exports = __webpack_public_path__ + "static/media/pink_green4.a5071bda.jpg";